import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/sentry";
import "@/globals.css";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "react-oidc-context";
import { I18nextProvider } from "react-i18next";
import { NuqsAdapter } from "nuqs/adapters/react";
import i18n from "@/lib/i18n";
import { onSigninCallback, userManager } from "./auth/config";
import { AuthManager } from "./auth/AuthManager";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const queryClient = new QueryClient({});

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <AuthProvider
          userManager={userManager}
          onSigninCallback={onSigninCallback}
        >
          <QueryClientProvider client={queryClient}>
            <AuthManager>
              <NuqsAdapter>
                <App />
              </NuqsAdapter>
            </AuthManager>
          </QueryClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>,
);
